import { HttpParams } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubSink } from 'subsink';
import * as moment from 'moment';
import { CALENDAR_LOCALE } from '../../../services/constant';
import { DownloadService } from '../download.service';
var DownloadListComponent = (function () {
    function DownloadListComponent(modalService, downloadService) {
        this.modalService = modalService;
        this.downloadService = downloadService;
        this.startDate = new Date(moment().format('YYYY') + '-01-01');
        this.endDate = new Date(moment().format('YYYY') + '-12-30');
        this.loading = false;
        this.currentPage = 1;
        this.itemsPerPage = 40;
        this.totalItems = 0;
        this.documentList = [];
        this.approvedList = [];
        this.isLoadingConfirm = false;
        this.showResults = false;
        this.successEmailList = [];
        this.failedEmailList = [];
        this.documentNumber = '';
        this.email = '';
        this.buyerName = '';
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.isCheckAll = false;
        this.subs = new SubSink();
    }
    DownloadListComponent.prototype.ngOnInit = function () {
        this.getDocumentRequestList();
    };
    DownloadListComponent.prototype.getDocumentRequestList = function () {
        var _this = this;
        this.loading = true;
        var params = new HttpParams()
            .set('page_size', this.itemsPerPage.toString())
            .set('page', this.currentPage.toString())
            .set('status', 'False')
            .set('email', this.email)
            .set('buyer_name', this.buyerName)
            .set('start_date', this.startDate ? moment(this.startDate).format('YYYY-MM-DD') : '')
            .set('end_date', this.endDate ? moment(this.endDate).format('YYYY-MM-DD') : '')
            .set('document_number', this.documentNumber);
        this.subs.add(this.downloadService.getDocumentRequestList(params).subscribe(function (documents) {
            _this.documentList = documents['results'];
            _this.totalItems = documents['count'];
            _this.loading = false;
        }, function (error) {
            console.log('error', error);
        }));
    };
    Object.defineProperty(DownloadListComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = new Date().getFullYear();
            return thisYear - 40 + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DownloadListComponent.prototype, "dateRange", {
        get: function () {
            var start = moment(this.startDate).format('DD/MM/YYYY');
            var end = moment(this.endDate).format('DD/MM/YYYY');
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    DownloadListComponent.prototype.search = function () {
        this.currentPage = 1;
        this.getDocumentRequestList();
    };
    DownloadListComponent.prototype.clearSearch = function () {
        this.documentNumber = '';
        this.startDate = new Date(moment().format('YYYY') + '-01-01');
        this.endDate = new Date(moment().format('YYYY') + '-12-30');
        this.email = '';
        this.buyerName = '';
        this.getDocumentRequestList();
    };
    DownloadListComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
        if (this.endDate < this.minDate) {
            this.endDate = this.minDate;
        }
    };
    DownloadListComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
        if (this.startDate > this.maxDate) {
            this.startDate = this.maxDate;
        }
    };
    DownloadListComponent.prototype.open = function (content) {
        this.showResults = false;
        this.modal = this.modalService.open(content);
    };
    DownloadListComponent.prototype.toggleStatusChange = function () {
        this.approvedList = this.documentList.filter(function (obj) { return obj.status; });
    };
    DownloadListComponent.prototype.confirm = function () {
        var _this = this;
        this.isLoadingConfirm = true;
        this.subs.add(this.downloadService.updateDocumentRequest(this.approvedList).subscribe(function (res) {
            _this.successEmailList = res.success_email_list;
            _this.failedEmailList = res.failed_email_list;
        }, function (error) {
            console.log('error', error);
        }, function () {
            _this.isLoadingConfirm = false;
            _this.showResults = true;
            _this.approvedList = [];
            _this.getDocumentRequestList();
        }));
    };
    DownloadListComponent.prototype.checkAll = function () {
        var _this = this;
        this.documentList.map(function (obj) {
            obj['status'] = _this.isCheckAll;
        });
        this.toggleStatusChange();
    };
    DownloadListComponent.prototype.deleteDownloadRequest = function (id) {
        var _this = this;
        this.downloadService.deleteDocumentRequest(id).subscribe(function () {
            _this.documentList = _this.documentList.filter(function (obj) { return obj.id !== id; });
        }, function (error) { return console.log('error', error); });
    };
    DownloadListComponent.prototype.optionChanged = function () {
        this.getDocumentRequestList();
    };
    DownloadListComponent.prototype.pageChanged = function () {
        this.getDocumentRequestList();
    };
    DownloadListComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    return DownloadListComponent;
}());
export { DownloadListComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/download/download-list/download-list.component.ts.pre-build-optimizer.js